module.exports = __webpack_public_path__ + "static/media/starwars.1911ba26.svg";